import React, { useState, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import Navbar from 'components/Header/Navbar';
import SupportTicketForm from 'components/support/SupportTicketForm';
import SupportTicketList from 'components/support/SupportTicketList';

const SupportPage: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [listKey, setListKey] = useState(0);
  const [formError, setFormError] = useState<string | null>(null);

  const handleFormSuccess = useCallback(() => {
    setListKey((k) => k + 1);
    setFormError(null);
  }, []);

  const handleFormError = useCallback((message: string) => {
    setFormError(message);
  }, []);

  if (!user) {
    navigate('/giris', { replace: true });
    return null;
  }

  return (
    <div className="min-vh-100 bg-light">
      <Navbar />
      <main className="container py-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h1 className="h4 mb-0">Teknik Destek</h1>
          <Link to="/" className="btn btn-outline-secondary btn-sm">
            <i className="fas fa-arrow-left me-1" /> Ana Sayfa
          </Link>
        </div>
        {formError && (
          <div className="alert alert-warning mb-3" role="alert">
            {formError}
          </div>
        )}
        <div className="row">
          <div className="col-lg-5 mb-4">
            <SupportTicketForm onSuccess={handleFormSuccess} onError={handleFormError} />
          </div>
          <div className="col-lg-7">
            <SupportTicketList key={listKey} />
          </div>
        </div>
      </main>
    </div>
  );
};

export default SupportPage;
